import { useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap"
import * as Yup from 'yup';
import { Field, Formik } from "formik";
import { FaRegEye } from "react-icons/fa";
import { LOGIN } from "../api/Routes";
import Post from '../api/Post'
import { AiOutlineUser } from "react-icons/ai";
import { withTranslation } from "react-i18next";

function LoginForm({t,i18n,setSuccess, setObjetoLogin}){    
    const [error, setError] = useState(null)
    const [isPassword, setIsPassword] = useState(true)

    const shema = Yup.object().shape({
        email: Yup.string()
            .email(t('Correoinvalido'))
            .required(t('Camporequerido')),
        password: Yup.string()
            .required(t('Camporequerido')),
    });
    
    return(
        <Formik
            initialValues={{email:'' ,password: ''}}
            validationSchema={shema}
            onSubmit={(values, { setSubmitting,setFieldValue }) => { 
                let d = {
                    username: values.email,
                    password: values.password
                }
                Post({url: LOGIN, data: d, header: false})
                .then(response=>{
                    //console.log(response)
                    if(response.data.hasOwnProperty("access_token")){
                        setSubmitting(false)
                        setObjetoLogin(response.data)
                        setSuccess(true)
                        i18n.changeLanguage(response.data.language)
                    }else{
                        setError(response.data.error.message)
                        setSubmitting(false)
                    }
                    
                    //setAuthData(response.data)
                    //history.replace('/admin')
                    
                })                
                .catch(error=>{
                    setSubmitting(false)
                    if(error.response){
                        if(error.response.data.status === 404){
                            setError(t('Credencialesincorrectas'))
                        }
                    }else{
                        setError(t('Error500'))
                    }
                })

            }}
        >{({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
        }) => (
            <Form onSubmit={handleSubmit}>
                {error && <label className="d-block text-danger text-center">{error}</label>}
                <Row className="justify-content-center mt-4">
                    <Col>
                        <Form.Group controlId="formBasicEmail">   
                            <InputGroup className="mb-3">
                                <Field 
                                    type="email" 
                                    name="email"
                                    className={`${errors.email && 'error'} form-control input-login border-right-0`}
                                    placeholder={t('Correoelectronico')}
                                />   
                                <InputGroup.Append>
                                    <InputGroup.Text 
                                        className={`${errors.email && 'error'} bg-transparent`}
                                    >
                                        <AiOutlineUser /> 
                                    </InputGroup.Text>
                                </InputGroup.Append>
                                { errors.email && <div className="invalid-feedback d-block">{errors.email}</div> }
                            </InputGroup>                            
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="justify-content-center mt-3">
                    <Col>
                        <Form.Group>    
                            <InputGroup className="mb-3">
                                <Field 
                                    type={isPassword ? 'password' : 'text'} 
                                    name="password"
                                    className={`${errors.password && 'error'} form-control input-login border-right-0`}
                                    placeholder={t('Contrasena')}
                                />   
                                <InputGroup.Append>
                                    <InputGroup.Text 
                                        className={`${errors.password && 'error'} bg-transparent cursor-pointer`} 
                                        onClick={e=>setIsPassword(!isPassword)}><FaRegEye /> </InputGroup.Text>
                                </InputGroup.Append>
                                { errors.password && <div className="invalid-feedback d-block">{errors.password}</div> }
                            </InputGroup>                        
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-2 align-items-center">
                    <Col xs="12" md="4" className="text-md-left text-center">
                        <Form.Check 
                            type="switch"
                            className="font-size-09rem"
                            id="custom-switch"
                            label={t('Recordarme')}
                        />
                    </Col>
                    <Col xs="12" md="8" className="text-md-right text-center">
                        <span className="btn btn-link text-primary2 font-size-09rem p-0 cursor-pointer no-underline">{t('Olvidastecontrasena')}</span>
                    </Col>
                </Row>
                <Row className="justify-content-center mt-3">
                    <Col xs="12" md="5">
                        <Button className="btn-login" block type="submit">
                            {
                                isSubmitting ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> :
                                t('Continuar')
                            }
                        </Button>
                    </Col>
                </Row>
            </Form>
        )}
        </Formik>
    )
}

export default withTranslation()(LoginForm)